import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImageSliceShowModule } from '../image-slice-show/image-slice-show.module';
import { ImageStoreModule } from '../image-store/image-store.module';
import { MultiSliceCanvasComponent } from './multi-slice-canvas/multi-slice-canvas.component';
import { MultiCanvasService } from './multi-canvas.service';
import { MultiCanvasControllerComponent } from './multi-canvas-controller/multi-canvas-controller.component';
import { CornerInfoModule } from '../corner-info/corner-info.module';
import { FlexLayoutModule} from '@angular/flex-layout';
import { ToolboxComponent } from './toolbox/toolbox.component';
@NgModule({
  declarations: [
    MultiSliceCanvasComponent,
    MultiCanvasControllerComponent,
    ToolboxComponent
  ],
  imports: [CommonModule, ImageSliceShowModule, ImageStoreModule, CornerInfoModule, FlexLayoutModule],
  providers: [MultiCanvasService],
  exports: [
    MultiSliceCanvasComponent,
    MultiCanvasControllerComponent,
    ToolboxComponent
  ],
})
export class MultiCanvasModule {}
